import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";

export const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
